import { render, staticRenderFns } from "./AIChatWidgetPdpScenePicker.vue?vue&type=template&id=a5b201be&scoped=true"
import script from "./AIChatWidgetPdpScenePicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpScenePicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpScenePicker.vue?vue&type=style&index=0&id=a5b201be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b201be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b201be')) {
      api.createRecord('a5b201be', component.options)
    } else {
      api.reload('a5b201be', component.options)
    }
    module.hot.accept("./AIChatWidgetPdpScenePicker.vue?vue&type=template&id=a5b201be&scoped=true", function () {
      api.rerender('a5b201be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetPdpScenePicker.vue"
export default component.exports